import {Component} from "@angular/core";

@Component({
    selector: "fui-append-field",
    styleUrls: ["./append-field.component.scss"],
    templateUrl: "./append-field.component.html",
    standalone: false
})
export class FUIAppendFieldComponent {

}
